export const SITE_URL = 'https://tinyspoon.app';
export const SITE_NAME = 'Tiny Spoon';
export const APP_STORE_URL = 'https://apps.apple.com/bg/app/tiny-spoon/id6754613061';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.f2digital.tinyspoon';
export const DEFAULT_DESCRIPTION =
  'Baby-led weaning meal plans, a food encyclopedia, and expert guidance for starting solids from 6 months.';
export const DEFAULT_IMAGE = `${SITE_URL}/icon.png`;

export function absoluteUrl(path = '/') {
  if (!path) return SITE_URL;
  if (path.startsWith('http')) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export function formatDate(isoDate, lang = 'en') {
  if (!isoDate) return '';
  const locales = { en: 'en-US', uk: 'uk-UA', ro: 'ro-RO' };
  try {
    return new Date(`${isoDate}T00:00:00`).toLocaleDateString(locales[lang] || 'en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return isoDate;
  }
}
